import React from 'react';
import { FaHeartbeat, FaDna, FaVirus, FaStethoscope, FaMicroscope } from 'react-icons/fa';

const Working = () => {
  return (
    <div className="w-full h-full min-h-screen bg-black text-gray-200 p-8">
      <h2 className="text-3xl font-bold mb-6 text-center text-white glow-effect " >
        Understanding How This Works
      </h2>
      
      <section className="mb-8">
        <h3 className="text-2xl font-semibold mb-3 flex items-center text-red-400">
          <FaHeartbeat className="mr-3" /> 
          The Heart of the Algorithm
        </h3>
        <p className="text-gray-200 leading-relaxed">
          This model isn't just throwing numbers around. It uses a smart point system to consider factors we know affect our health, like cardiovascular issues and lifestyle habits. Every question digs a little deeper into areas that could shape your life expectancy. From heart health to cancer signs, we’re looking at the big picture.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-2xl font-semibold mb-3 flex items-center text-green-400">
          <FaDna className="mr-3" /> 
          How Scoring Works
        </h3>
        <p className="text-gray-200 leading-relaxed">
          Not all health issues are created equal. So, some factors get higher points than others, especially those that have a huge impact on life expectancy, like heart disease and cancer. Think of it as a ranking system where your risks and habits weigh in, based on solid health data.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-2xl font-semibold mb-3 flex items-center text-yellow-400">
          <FaVirus className="mr-3" /> 
          The Science Behind It
        </h3>
        <p className="text-gray-200 leading-relaxed">
          Everything here is grounded in research from trusted sources, like the World Health Organization (WHO) and CDC. The model uses data on life expectancy and common health risks to give you a realistic look at your potential lifespan. It’s all based on numbers and facts, not guesswork.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-2xl font-semibold mb-3 flex items-center text-purple-400">
          <FaStethoscope className="mr-3" /> 
          What Your Score Means
        </h3>
        <p className="text-gray-200 leading-relaxed">
          So, what do these points tell you? Simply put, the fewer points you score, the better your outlook. A higher score might mean there are some health risks to consider. But remember, this isn’t a final diagnosis – it’s a tool to help you see where you stand. Always check in with a healthcare provider for a personal assessment.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-2xl font-semibold mb-3 flex items-center text-blue-400">
          <FaMicroscope className="mr-3" /> 
          Facts, Research & Updates
        </h3>
        <p className="text-gray-200 leading-relaxed">
          This model doesn’t rest on old data. It’s regularly updated to keep up with new scientific findings. Every risk factor and lifestyle habit we consider is backed by research, so you can trust that your results are based on the latest in medical science.
        </p>
      </section>
      <style jsx>{`
        .glow-effect {
          text-shadow: 
            0 0 5px rgba(0, 204, 255, 0.7),
            0 0 10px rgba(0, 204, 255, 0.7),
            0 0 20px rgba(0, 204, 255, 0.7),
            0 0 40px rgba(0, 204, 255, 0.7),
            0 0 80px rgba(0, 204, 255, 0.7);
        }
      `}</style>
    </div>
    
  );
  
};

export default Working;
